import { ReactElement } from "react"

// Thin shell: takes a list of step ReactElements and the active index, renders
// the matching child. The hosting page owns the index (so it can advance after
// async work completes) and the per-flow in-flight state (jotai atoms).
type StepperProps = {
  steps: ReactElement[]
  currentStep: number
}

const Stepper = ({ steps, currentStep }: StepperProps) =>
  steps[currentStep] ?? null

export default Stepper
